const notifications = {
    configSMTP: {},
    configSMS: {},
    email: {},
    sms: {},
    loadingNotifications: true
};

export default notifications;
